import { withRouter } from '01_core/components/system/CustomRouter';
import React from 'react';
import { injectIntl } from 'react-intl';

import Collapse from '@mui/material/Collapse';

import MenuItem from './MenuItem';

export class MenuListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
    };
  }

  handleMenuClick = () => {
    if (this.props.actionCd === '2') {
      this.props.onClick();
    } else if (this.props.actionCd === '1') {
      // メニュークリック時は必ずダミーのコンポーネントを呼ぶ
      this.props.history.push('/rendering?' + this.props.name);
      // メニュークリック時はメニューバーを閉じる
      this.props.closeMenuBar();
    } else if (this.props.actionCd === '0') {
      this.setState({ menuOpen: !this.state.menuOpen });
    }
  };

  render() {
    const { name, intl, Icon, itemClass, children } = this.props;

    return (
      <React.Fragment>
        <MenuItem
          onClick={(e) => {
            this.handleMenuClick();
          }}
          itemClass={itemClass}
          Icon={Icon}
          menuText={intl.formatMessage({ id: 'menu.' + name })}
        />
        <Collapse in={this.state.menuOpen} timeout='auto' unmountOnExit>
          {children}
        </Collapse>
      </React.Fragment>
    );
  }
}

export default withRouter(injectIntl(MenuListItem));
